import { Column } from "primereact/column"
import { DataTable } from "primereact/datatable"
import "primereact/resources/themes/viva-dark/theme.css";
import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import WorkerLeaveReport from "./WorkerLeaveReport";
import AvatarMini from "components/commons/AvatarMini";

function WorkerContractTable({
    workersData,
    toggleStatus = () => { }
}) {

    const [t, i18n] = useTranslation(["global"])
    const [expandedRows, setExpandedRows] = useState(null);
    const dt = useRef(null);



    const expandAll = () => {
        let _expandedRows = {};

        workersData.forEach((p) => (_expandedRows[`${p.guid}`] = true));

        setExpandedRows(_expandedRows);
    };

    const collapseAll = () => {
        setExpandedRows(null);
    };

    /**
     *
     *  TEMPLATE HOLDERS 
     * 
     * */


    const actionsTemplate = (worker) => {
        return (
            <>
                <NavLink to={{ pathname: "/dashboard/employees/see-employment" }} state={{ userGUID: worker.user.guid }} className="btn btn-light me-1"><i className="fa-solid fa-eye"></i></NavLink>
            </>
        )
    }

    const userAvatarTemplate = (worker) => {
        return (
            <>
                <AvatarMini displayName={worker.user.displayName} guid={worker.user.guid} />
            </>
        )
    }

    const rowExpansionTemplate = (data, options) => {
        console.log("RowExpanded: " + data.user.displayName)
        //"p-row-odd" --> options.index % 2 --> isOdd?
        return (
            <div className="container">
                <div className="row px-4 align-items-start">
                    <div className="col px-4">
                        {

                            <WorkerLeaveReport userGUID={data.user.guid} isEditable={true} />
                        }
                        
                    </div>
                </div>


            </div>
        )
    }



    /**
     *
     *  ACTION HANDLERS 
     * 
     * */

    const handleChangeStatus = (e, guid) => {
        console.log("Set status: " + e.target.checked + " on userGuid: " + guid)
        toggleStatus(e.target.checked, guid)
    }


    const exportCSV = (selectionOnly) => {
        dt.current.exportCSV({ selectionOnly });
    };

    return (
        <>
            <DataTable
                value={workersData}
                stripedRows
                tableStyle={{ minWidth: '50rem' }}
                paginator rows={25}
                rowsPerPageOptions={[5, 10, 25, 50]}

                dataKey="guid"
                expandedRows={expandedRows}
                onRowToggle={(e) => setExpandedRows(e.data)}
                rowExpansionTemplate={rowExpansionTemplate}

                ref={dt}
            >
                <Column expander={() => { return true }} style={{ width: '5rem' }} />
                <Column field="user.displayName" header={t("property.name")} body={userAvatarTemplate} filterPlaceholder="Search by name" sortable filter ></Column>
                <Column field="workerClass.name" header={t("absenceReport:property.contractual_level")} sortable></Column>
                <Column field="employmentDate" header={"Data ass."} sortable></Column>
                <Column field="weeklyHours" header={"Ore sett."} sortable></Column>
                <Column body={actionsTemplate} header={t("property.actions")}></Column>
            </DataTable>
            <div className="container text-end p-2">
                <h6>{t("action.export")}</h6>
                <button className="btn btn-primary" onClick={() => exportCSV(false)}><i className="fa-solid fa-download"></i> .CSV</button>
            </div>
        </>


    )

}

export default WorkerContractTable